// extracted by mini-css-extract-plugin
export var active = "_id-7";
export var blink = "_id-8";
export var dropDownSelector = "_id-4";
export var dropDownWrapper = "_id-3";
export var fakeCursor = "_id-6";
export var fontSizeButton = "_id-9";
export var formQuillEditor = "_id-0";
export var pressed = "_id-a";
export var qlBlank = "_id-1";
export var textFormattingToolbar = "_id-2";
export var textToolbarOption = "_id-5";